import { Link, NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

const LOGO =
    "https://customer-assets.emergentagent.com/job_74007a75-e0c2-4452-bdc7-515e3dc56401/artifacts/qxxe8th0_K%20%E2%80%A2TEAM.png";

const links = [
    { to: "/", label: "Home" },
    { to: "/events", label: "Events" },
    { to: "/shop", label: "Shop" },
    { to: "/fly-muse", label: "The Fly Muse" },
];

export default function Nav() {
    const [scrolled, setScrolled] = useState(false);
    const { pathname } = useLocation();

    useEffect(() => {
        const onScroll = () => setScrolled(window.scrollY > 24);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    return (
        <header
            data-testid="site-header"
            className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
                scrolled
                    ? "bg-[var(--bg-base)]/85 backdrop-blur-md border-b border-[var(--ink)]/15"
                    : "bg-transparent"
            }`}
        >
            <div className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16 flex items-center justify-between h-16 md:h-20">
                <Link
                    to="/"
                    className="flex items-center gap-3 group"
                    data-testid="nav-logo-link"
                >
                    <img
                        src={LOGO}
                        alt="K•TEAM"
                        className="h-9 md:h-10 w-auto"
                        style={{ filter: "invert(1) brightness(0)" }}
                    />
                    <span className="font-mono-acc text-[10px] tracking-[0.32em] uppercase text-[var(--muted)] hidden md:inline-block">
                        EST · 2025
                    </span>
                </Link>

                <nav className="flex items-center gap-1 md:gap-2">
                    {links.map((l) => (
                        <NavLink
                            key={l.to}
                            to={l.to}
                            data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                            className={({ isActive }) =>
                                `relative px-3 md:px-5 py-2 font-mono-acc text-[11px] md:text-xs tracking-[0.22em] uppercase transition-colors duration-300 ${
                                    isActive
                                        ? "text-[var(--ink)]"
                                        : "text-[var(--muted)] hover:text-[var(--ink)]"
                                }`
                            }
                        >
                            {({ isActive }) => (
                                <>
                                    <span>{l.label}</span>
                                    <span
                                        className={`absolute left-3 right-3 md:left-5 md:right-5 -bottom-0.5 h-px bg-[var(--ink)] transition-transform duration-500 origin-left ${
                                            isActive
                                                ? "scale-x-100"
                                                : "scale-x-0"
                                        }`}
                                    />
                                </>
                            )}
                        </NavLink>
                    ))}
                </nav>
            </div>

            {/* sub-rule */}
            <div
                className={`max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16 transition-opacity duration-500 ${
                    scrolled ? "opacity-0" : "opacity-100"
                }`}
            >
                <div className="h-px bg-[var(--ink)]/15 -mt-px" />
            </div>
        </header>
    );
}
